export enum PartnerType {
  CORRESPONDENTE = 'CORRESPONDENTE',
  LOTERICO = 'LOTERICO',
}
